import { TwoWayRequestProcessingFieldName } from '../services/request-processing.types';

export const REQUEST_PROCESSING_SORT_FIELD: Record<string, TwoWayRequestProcessingFieldName> = {
  deviceId: TwoWayRequestProcessingFieldName.DeviceUId,
  commDeviceId: TwoWayRequestProcessingFieldName.CommDeviceId,
  serialNumber: TwoWayRequestProcessingFieldName.SerialNumber,
  deviceType: TwoWayRequestProcessingFieldName.DeviceType,
  command: TwoWayRequestProcessingFieldName.RequestType,
  commandStatus: TwoWayRequestProcessingFieldName.RequestStatus,
  createdOnDateTime: TwoWayRequestProcessingFieldName.CreatedOnUTC,
  scheduledDateTime: TwoWayRequestProcessingFieldName.ScheduledDateTimeUtc,
  startDateTime: TwoWayRequestProcessingFieldName.StartDateTimeUtc,
  completedDateTime: TwoWayRequestProcessingFieldName.EndDateTimeUtc,
  actionName: TwoWayRequestProcessingFieldName.CommandGroupName,
  imageName: TwoWayRequestProcessingFieldName.ImageName,
  user: TwoWayRequestProcessingFieldName.User
};
